const trimTrailingSlash = (value = "") => {
  let end = value.length;

  while (end > 0 && value.charCodeAt(end - 1) === 47) {
    end -= 1;
  }

  return value.slice(0, end);
};

const toAbsoluteBase = (value) => {
  if (!value) return "";

  try {
    const parsed = new URL(value);
    return trimTrailingSlash(parsed.origin);
  } catch (_) {
    // Relative values (for example "/api") should still resolve to current origin.
    if (value.startsWith("/") && typeof window !== "undefined") {
      return trimTrailingSlash(window.location.origin);
    }
    return trimTrailingSlash(value);
  }
};

const getMediaBaseUrl = () => {
  const uploadsBase = process.env.REACT_APP_UPLOADS_BASE_URL;
  if (uploadsBase) return toAbsoluteBase(String(uploadsBase).trim());

  const apiBase = process.env.REACT_APP_API_URL;
  if (apiBase) return toAbsoluteBase(String(apiBase).trim());

  return "";
};

const isAbsolute = (value) =>
  /^(https?:)?\/\//i.test(value) || value.startsWith("data:") || value.startsWith("blob:");

const normalizePath = (value) => (value.startsWith("/") ? value : `/${value}`);

export const resolveMediaUrl = (path, fallback = "") => {
  if (!path || typeof path !== "string") return fallback;

  const cleanPath = path.trim();
  if (!cleanPath) return fallback;
  if (isAbsolute(cleanPath)) return cleanPath;

  const base = getMediaBaseUrl();
  const normalizedPath = normalizePath(cleanPath);

  if (!base) return normalizedPath;
  return `${base}${normalizedPath}`;
};

export default resolveMediaUrl;
